import { makeStyles, tokens } from '@fluentui/react-components';

export const usePoliticalAdsDeclarationStyles = makeStyles({
  root: {
    paddingTop: tokens.spacingVerticalXXL,
    paddingBottom: tokens.spacingVerticalXXL,
    paddingLeft: tokens.spacingHorizontalXXL,
    paddingRight: tokens.spacingHorizontalXXL,
  },
  checkbox: {
    '& .fui-Label': {
      fontSize: tokens.fontSizeBase300,
      fontStyle: 'normal',
      fontWeight: tokens.fontWeightRegular,
      lineHeight: tokens.lineHeightBase300,
      paddingTop: '5px',
      paddingBottom: '7px',
    },
  },
  labelContent: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: tokens.spacingVerticalXS,
  },
  dialogContent: {
    paddingBottom: tokens.spacingVerticalXS,
  },
});
